export const getOrderValue = (unitPrice: number, quantity: number): number =>
  Math.round(unitPrice * quantity * 100) / 100;
